module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/mobile@2x-6469566f630ec138727f50fe54ac9781.jpg";